/* eslint-disable jsx-a11y/accessible-emoji */
import React, {Component} from 'react';
import axios from 'axios';
import firebase from 'utils/firebase';
import {connect} from 'react-redux';
import {getSortedFollowingStrategies} from 'selectors/followingStrategies';
import Strategy from 'components/Cards/Strategy';
import {Loader} from 'components/Loader';

import '../style.scss';

class TopStrategies extends Component {
  state = {
    loading: true,
    trendingStrategies: [],
  };

  async componentDidMount() {
    try {
      const userToken = await firebase.auth().currentUser.getIdToken();
      const trendingStrategies = await axios.get('/v3/trending/strategies', {
        headers: {token: userToken},
      });
      this.setState({trendingStrategies: trendingStrategies.data, loading: false});
    } catch (error) {
      console.error(error);
    }
  }

  onSubsAmountIncrement = followedStrategy => {
    this.setState(prevState => ({
      trendingStrategies: [
        ...prevState.trendingStrategies.map(strategy => {
          if (strategy.id === followedStrategy.id) {
            return {...strategy, subsAmount: strategy.subsAmount + 1};
          }
          return strategy;
        }),
      ],
    }));
  };

  onSubsAmountDecrement = unfollowedStrategy => {
    this.setState(prevState => ({
      trendingStrategies: [
        ...prevState.trendingStrategies.map(strategy => {
          if (strategy.id === unfollowedStrategy.id) {
            return {...strategy, subsAmount: strategy.subsAmount - 1};
          }
          return strategy;
        }),
      ],
    }));
  };

  renderContent = () => {
    const {followingStrategies, onFollowStrategy, onUnfollowStrategy} = this.props;

    return this.state.trendingStrategies
      .filter(({id}) => !this.props.followingStrategies.some(str => str.id === id))
      .map(strategy => (
        <Strategy
          key={strategy.id}
          strategy={strategy}
          strategyId={strategy.id}
          followingStrategies={followingStrategies}
          onFollowStrategy={onFollowStrategy}
          onUnfollowStrategy={onUnfollowStrategy}
          onSubsAmountIncrement={this.onSubsAmountIncrement}
          onSubsAmountDecrement={this.onSubsAmountDecrement}
        />
      ));
  };

  renderEmpty = () => (
    <div className="no-strategies">Sorry, but there are no strategies at the moment. Please check again later.</div>
  );

  renderAllStrategiesAreFollowed = () => (
    <div className="no-strategies">
      We run out of strategies you can follow! <span className="text-emoji">&#128532;</span>
      This is the first time we see it! <span className="text-emoji">&#x1F631;</span> <br />
      Be sure we are working hard to add more profitable strategies, so you won’t see this message anymore{' '}
      <span className="text-emoji">&#x1F9D0;</span>
    </div>
  );

  render() {
    const {loading, trendingStrategies} = this.state;
    const {followingStrategies} = this.props;
    const isAllTrendingStrategiesAreFollowed = trendingStrategies.length === followingStrategies.length;

    if (loading) return <Loader />;

    return (
      <div className="strategies-page">
        {trendingStrategies.length ? this.renderContent() : this.renderEmpty()}
        {isAllTrendingStrategiesAreFollowed && this.renderAllStrategiesAreFollowed()}
      </div>
    );
  }
}

export default connect(state => ({
  followingStrategies: getSortedFollowingStrategies(state),
}))(TopStrategies);
